import initialState from './initialState'
import * as types from '../actions/actionTypes'

const synthesis = (state = initialState.synthesis, action) => {
  switch (action.type) {
    case types.GET_SYNTHESIS:
      return { ...state, htmlSynthesis: action.synthesis }
    default:
      return state
  }
}

export default synthesis



// WEBPACK FOOTER //
// ./src/reducers/synthesisReducer.js